import React, { useEffect } from 'react'
import { RouteComponentProps } from '@reach/router'
import { PanelContent } from '../../../components/panel-content'
import { Button } from '../../../components/button'
import { useStateValue } from '../../../components/state'
import { MapFact } from '../../../components/map-fact'
import { useDelayedBoolean } from '../../../hooks/use-delayed-boolean'
import { TextLink } from '../../../components/text-link'

export const GroundWater: React.FC<RouteComponentProps> = () => {
  const [, dispatch] = useStateValue()

  // Filter map pins to desalination
  useEffect(() => {
    dispatch({
      type: 'setActiveMarkerType',
      payload: { activeMarkerType: 'groundwater' }
    })
  }, [dispatch])

  const fact1Visible = useDelayedBoolean({ delay: 500, toggle: 10000 })
  const fact2Visible = useDelayedBoolean({ delay: 10500, toggle: 10000 })

  return (
    <PanelContent>
      <h1>Groundwater</h1>
      <p>
        <TextLink href='https://www.watercorporation.com.au/Our-water/Groundwater'>
          Groundwater
        </TextLink>{' '}
        comes from rain trickling down through soils into the ground. Our
        groundwater supplies are stored in natural reservoirs called aquifers,
        which get topped up by rainfall. But, as we're getting less rain, our
        groundwater supply is declining.
      </p>
      <p>
        Groundwater is a vital source for Perth’s water needs, making up around
        40% of our supply. That's why we're expanding our groundwater network,
        while also using climate-independant water sources like{' '}
        <TextLink href='https://www.watercorporation.com.au/Our-water/Groundwater/Groundwater-replenishment'>
          desalination and groundwater replenishment
        </TextLink>
        .
      </p>
      <MapFact
        aboveValue="Aquifers aren't underground lakes like you might imagine. They're actually made up of sand and limestone which allow water to move through the particles."
        visible={fact1Visible}
        position='bottom-left'
      />
      <MapFact
        aboveValue='Our local parks and playing fields are irrigated with groundwater, we all need to protect it to keep these places green for our health and enjoyment.'
        visible={fact2Visible}
        position='top-right'
      />
      <Button href='/why'>Why does my water come from groundwater?</Button>
    </PanelContent>
  )
}
